import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { logout } from '../../redux/actions/authAction'

const Header = ({ onToggleMenu }) => {
    const dispatch = useDispatch()
    const user = useSelector(state => state.auth.user)

    return (
        <div className="Header">
            <div className="Logo">
                <Link to="/dashboard" className="BrandLogo">
                    <i className="fa fa-file-text-o" aria-hidden="true"></i>
                    <span>DocScanner <b>CRM</b></span>
                </Link>
            </div>
            <div className="Navigation">
                <button type="button" className="MenuToggle" onClick={onToggleMenu} aria-label="Toggle menu">
                    <i className="fa fa-bars" aria-hidden="true"></i>
                </button>
                <div className="Avater">
                    <span className="AvaterLabel">
                        <figure><i className="fa fa-user" aria-hidden="true"></i></figure>
                        <span className="AvaterEmail">{user?.email || 'Admin'}</span>
                    </span>
                    <button type="button" className="LogoutBtn" onClick={() => dispatch(logout())} title="Log out">
                        <i className="fa fa-sign-out" aria-hidden="true"></i> <span>Logout</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Header
